import { memo } from "react"
import type { ModalType } from "./ModalContext"
import type { ModalProps } from "./ModalProvider"

interface ModalRendererProps<Props> {
	/**
	 * Functional component representing the modal
	 */
	component: ModalType<Props>["component"]
	/**
	 * The props of the modal
	 */
	props: ModalProps
}

/**
 * Component responsible for rendering the modal.
 *
 * The identity of `Component` may change depending on the inputs passed to
 * `useModal`. If we simply rendered `<Component />` then the modal would be
 * susceptible to rerenders whenever one of the inputs change.
 */
export const ModalRenderer = memo(({ component: Component, props }: ModalRendererProps<any>) => {
	return <Component id={props.id} modalProps={props.modalProps} />
})

ModalRenderer.displayName = "ModalRenderer"
